import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { treatExperiment } from 'src/app/shared/api/experiments';
import { isMobile } from 'src/app/shared/utils/userAgent';

import type { PsfShareDataQuery } from '../api.graphql';

type Experiment = NonNullable<PsfShareDataQuery['experiments']>['supporterGrowthPsfShareAssetsExperiment'];

type Params = {
	experiment: Experiment;
	hasBestShareVisual: boolean;
	utilityContext: UtilityContext;
};

export async function normalizeSupporterGrowthPsfShareAssetsExperiment({
	experiment,
	hasBestShareVisual,
	utilityContext,
}: Params): Promise<Experiment['variation']> {
	if (shouldRunExperiment({ experiment, hasBestShareVisual, utilityContext })) {
		await treatExperiment(utilityContext, experiment.experimentName);
		return experiment.variation;
	}
	return 'control';
}

function shouldRunExperiment({ experiment, hasBestShareVisual, utilityContext }: Params): boolean {
	return isEnabledByFC(experiment) && hasBestShareVisual && isMobile(utilityContext);
}

// The experiment in the GraphQL response is always an object. If there is no FC, or the experiment name in the FC is empty
// or invalid, the experimentName property from GraphQL is set to '__invalid_experiment__' per the configuration in
// packages/experiments/src/configs/configs/supporter_growth_psf_share_assets_experiment.ts
function isEnabledByFC(experiment: Experiment): boolean {
	return experiment.experimentName !== '__invalid_experiment__' && experiment.experimentName !== '';
}
